<template>
  <div class="screen page formActions b-soft">
    <div class="grid">
      {{validateData}}
      <form v-on:submit.prevent="actionForm()" class="form layout">
        <div class="container">
          <div class="row">
            <div class="col-4" v-bind:class="{'filled': nombre != ''}">
              <label for="nombre">Nombre</label>
              <input id="nombre" type="text" v-model="nombre" placeholder="Escribe algo...">
            </div>
            <div class="col-4" v-bind:class="{'filled': montoInicial > 0}">
              <label for="montoInicial">Monto Inicial</label>
              <input id="montoInicial" type="tel" v-model="montoInicialFormateado" placeholder="0.00">
            </div>
            <div class="col-4" v-bind:class="{'filled': montoActual > 0}">
              <label for="montoActual">Monto Actual</label>
              <input id="montoActual" type="tel" v-model="montoActualFormateado" placeholder="0.00">
            </div>
            <div class="col-12">
              <label for="color">Selecciona un Color</label>
              <swatches v-model="color" :colors="colors" row-length="8" popover-to="right" swatch-size="30"></swatches>
            </div>
            <div class="col-12">
              <ul v-if="messages.length" class="messages-container">
                <p class="t-14-px">Verifica lo siguiente:</p>
                <li v-for="(message, index) in messages" v-bind:class="['message-item t-12-px', message.type]"><i class="fas fa-times" @click.prevent.stop="delete_message(message)"></i> {{message.content}}</li>
              </ul>
            </div>
            <div class="col-12">
              <button v-if="id" type="submit" class="btn b-secondary">Guardar Cambios</button>
              <button v-else type="submit" class="btn b-secondary">Crear Nuevo Elemento</button>
            </div>
          </div>
        </div>
      </form>
      <GetFooter />
    </div>
  </div>
</template>

<script>
import GetFooter from '@/components/footer.vue'
import Swatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.css'
import router from '@/router'
import {getColors} from '@/colors.js'
import { db } from '@/firebase'
export default {
  name: 'app',
  components: {
    GetFooter,
    Swatches
  },
  data() {
    return {
      action_state: true, 
      id: this.$route.params.id,
      nombre: '',
      montoInicial: 0.00,
      montoInicialFormateado: 0.00,
      montoActual: 0.00,
      montoActualFormateado: 0.00,
      color: '#1FBC9C',
      cuentas: [],
      messages: [],
      colors: getColors
    }
  },
  firestore () {
    if(this.id){
      return {
        cuentas: db.collection('cuentas').doc(this.id)
      }
    }
  },
  watch: {
    nombre () {
      this.varificar_modificaciones
    },
    montoInicial () {
      this.montoInicialFormateado = this.$options.filters.formatNumber(this.montoInicial)
      this.varificar_modificaciones
    },
    montoInicialFormateado () {
      this.montoInicial = this.$options.filters.cleanFormat(this.montoInicialFormateado)
      this.montoInicialFormateado = this.$options.filters.formatNumber(this.montoInicial)
    },
    montoActual () {
      this.montoActualFormateado = this.$options.filters.formatNumber(this.montoActual)
      this.varificar_modificaciones
    },
    montoActualFormateado () {
      this.montoActual = this.$options.filters.cleanFormat(this.montoActualFormateado)
      this.montoActualFormateado = this.$options.filters.formatNumber(this.montoActual)
    }
  },
  beforeRouteLeave (to, from, next) {
    if(this.action_state){
      next()
    }else{
      const answer = window.confirm('¿Estás Seguro? Se perderá la información que se haya modificado')
      if(answer){
        next()
      } else {
        next(false)
      }
    }
  },
  computed: {
    validateData (){
      if(this.id){
        this.nombre = this.cuentas.nombre
        this.montoInicial = Number(this.cuentas.valor_inicial).toFixed(2)
        this.montoActual = Number(this.cuentas.valor_actual).toFixed(2)
        this.color = this.cuentas.color
      }
    },
    varificar_modificaciones (){
      //Siempre y cuando no se este editando un movimiento verificar si se modifico un campo
      if(!this.id){
        if(this.nombre != '' || this.montoInicial > 0 || this.montoActual > 0){
          //Si se ha modificado cualquiera de los campos preguntar antes de salir
          this.action_state = false
        }else{
          this.action_state = true
        }
      }else{
        this.action_state = false
      }
    }
  },
  methods: { 
    delete_message (value){
     this.messages.splice(this.messages.indexOf(value), 1)
    },
    actionForm () {
      const id_cuenta = this.id
      var item_nombre = this.nombre
      var item_monto_inicial = this.montoInicial
      var item_monto_actual = this.montoActual
      var item_color = this.color
      var item_creacion = new Date()
      var item_orden = this.cuentas.length + 1

      this.messages = []

      if(!item_nombre) {
        const the_message = {
          type: 'fatal b-fail',
          content: 'Es necesario ingresar un nombre'
        }
        this.messages.push(the_message)
      }

      if(!item_monto_inicial) {
        const the_message = {
          type: 'fatal b-fail',
          content: 'Es necesario ingresar un monto inicial'
        }
        this.messages.push(the_message)
      }

      if(!item_monto_actual) {
        const the_message = {
          type: 'fatal b-fail',
          content: 'Es necesario ingresar un monto actual'
        }
        this.messages.push(the_message)
      }

      if(!item_color) {
        const the_message = {
          type: 'fatal b-fail',
          content: 'Es necesario seleccionar un color'
        }
        this.messages.push(the_message)
      }

      if(!this.messages.length) {
        this.action_state = true
        if(id_cuenta){
          db.collection('cuentas').doc(id_cuenta).update({
            color: item_color,
            fecha_modificacion: item_creacion,
            nombre: item_nombre,
            valor_inicial: Number(item_monto_inicial),
            valor_actual: Number(item_monto_actual)
          })
          .then(function(docRef) {
              //router.push('/account/'+id_cuenta)
          })
          .catch(function(error) {
              //router.replace('/accounts')
          })
          router.push('/account/'+id_cuenta)
        }else{
          db.collection('cuentas').add({
            color: item_color,
            fecha_creacion: item_creacion,
            fecha_modificacion: item_creacion,
            nombre: item_nombre,
            orden: Number(item_orden),
            valor_inicial: Number(item_monto_inicial),
            valor_actual: Number(item_monto_actual)
          })
          .then(function(docRef) {
              //router.replace('/account/'+docRef.id)
          })
          .catch(function(error) {
              //router.replace('/accounts')
          })
          router.replace('/accounts')
        }
      }
      
    }
  }
}
</script>